import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss'],
})
export class CustomerListComponent implements OnInit {

  customerKeyword: any = "";
  @Input() activeMemberList: any[];
  @Input() customerIdDisplay:any;
  @Input() token: any;
  @Input() viewOnly:any;
  customerList: any[] = [];
  customers: any[]=[];
  keyword:any;
  checkedAllCustomer : boolean = false;
  @ViewChild('customerComponent', { static: false }) customerComponent: IonicSelectableComponent;
  
  
  constructor(
    public modalController: ModalController,
    private toastCtrl: ToastController,
    private alertController: AlertController,
  ) { }

  ngOnInit() {
    this.setcustomerList();
  }

  setcustomerList() {
    this.customerList = [];
    console.log( this.customerIdDisplay);
    let listCustomer: any[] = this.customerIdDisplay.trim().split(',');
    console.log( listCustomer);
    if(listCustomer.length > 0) {
      for(let i = 0; i < listCustomer.length; i++) {
        let customer: any =this.activeMemberList.find(x=> x.id.toString()===listCustomer[i]);
        if(customer){
          this.customerList.push({
            id: customer.id,
            phone: customer.phone,
            customer_name: customer.customer_name
          });
        }
      }
    }
    console.log(this.customerList);
  }
  async getCustomer(customerKeyword: any) {
    this.keyword=customerKeyword;
    this.customers = [];
    console.log(this.activeMemberList);
    if(this.keyword.length >= 3) {
      let customer: any =this.activeMemberList.filter(x=>x.id!=null && (x.customer_name != null && x.customer_name.toUpperCase().includes(this.keyword.toUpperCase()) || (x.phone !==null && x.phone.includes(this.keyword.toUpperCase()))));
      if(customer.length >0){
        for(let g=0;g<customer.length;g++){
          this.customers.push({
            id: customer[g].id,
            phone: customer[g].phone,
            customer_name: customer[g].customer_name
          });
        }
      }
    }
    else{
      this.toastCtrl.create({ duration: 2000, message: 'Minimum 3 karakter' }).then(t => t.present());
    }
  }

  async dismissModal() {
    await this.modalController.dismiss(this.customerList.length > 0 ? this.customerList : '');
  }

  scrollDownEnd() {
    setTimeout(()=>{   
        var elem = document.getElementById('item');
        elem.scrollTop = elem.scrollHeight;
    }, 50);
  }

  deleteDetail(index: any) {
    this.customerList.splice(index, 1);
  }

  chooseCustomer(customer: any) {
    if(customer !== '' && customer !== undefined) {
      let checkItemPcode: any[] = this.customerList.find(x => x.id === customer.id);
      if (checkItemPcode === undefined) {
        this.customerList.push({
          id: customer.id,
          phone: customer.phone,
          customer_name: customer.customer_name
        });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Customer sudah ada di list!' }).then(t => t.present());
      }
    }
    (<HTMLInputElement>document.getElementById("customerKeyword")).focus();
  }
  
  toggleCounterItems() {
    this.customerComponent.toggleItems(
      this.customerComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.customerComponent.confirm();
    this.customerComponent.close();
    
    let selectedcustomerList = [];
    selectedcustomerList = this.customerComponent.value;
    for(let i=0;i<selectedcustomerList.length;i++){
      let idCustomer = selectedcustomerList[i].id;
      let findCustomer = this.customers.find(x=>x.id==idCustomer)
      if(findCustomer){
        this.customerList.push({
          id: findCustomer.id,
          phone: findCustomer.phone,
          customer_name: findCustomer.customer_name
        });
      }
    }
  }
  
  selectCheckboxCounter(customer_id:any,checked:any){
    if(this.customers.length > 0) {
      let Checbox = (this.customers.find(x => x.id === customer_id));
     let indexChecbox = (this.customers.findIndex(x => x.id === customer_id));
      if(checked=='check'){
        this.customers[indexChecbox].isChecked=true;
        let cari =this.customerList.find(x=>x.id==customer_id);
        if(cari==undefined){
          this.chooseCustomer(Checbox);
          if(this.customerList.length==this.customers.length){
            this.checkedAllCustomer=true;
          }
          else{
            this.checkedAllCustomer==false;
          }
        }
      }
      else{
        this.customers[indexChecbox].isChecked=false;
        let cari =this.customerList.find(x=>x.id==customer_id);
        if(cari!==undefined){
          let index = this.customerList.indexOf(cari);
          this.customerList.splice(index, 1);
          this.checkedAllCustomer=false;
        }
      }
    }
    
  }
  uncheckAllCustomer() {
    if(this.customers.length > 0) {
      for(let i = 0; i < this.customers.length; i++) {
        if(this.checkedAllCustomer === true) {
          this.customers[i].isChecked = false; 
          let cari =this.customerList.find(x=>x.id==this.customers[i].id);
          if(cari!==undefined){
            let index = this.customerList.indexOf(cari);
            this.customerList.splice(index, 1);
          }      
        }else{
          this.customers[i].isChecked = true;
          let cari =this.customerList.find(x=>x.id==this.customers[i].id);
          if(cari==undefined){
            this.chooseCustomer(this.customers[i]);
          }
        }
      }
      if(this.checkedAllCustomer === true) {
        this.checkedAllCustomer = false;
      }
      else{          
        this.checkedAllCustomer = true;
      }
    }
  }
}
